import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logError } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

export interface BulkSubmitPaPayload {
  file: File;
  org_id: string;
  max_rows?: number;
}

export const bulkSubmitPa = async (
  payload: BulkSubmitPaPayload,
): Promise<any> => {
  try {
    const token = await getBearerToken();

    if (!token) {
      throw new Error("No token found");
    }

    // Create FormData for multipart/form-data request
    const formData = new FormData();
    formData.append("file", payload.file);
    formData.append("org_id", payload.org_id);
    formData.append("max_rows", (payload.max_rows || 500).toString());

    const response = await fetch(API_ENDPOINTS.BULK_SUBMIT_PA, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        // Don't set Content-Type header, browser will set it with boundary
      },
      body: formData,
    });

    if (response.status >= 400) {
      const errorText = await response.text();
      logError(new Error(errorText), "Error in bulkSubmitPa");
    }

    const result = await response.json();
    return {
      success: true,
      message: "PA submitted successfully",
      data: result,
    };
  } catch (error) {
    logError(error as Error, "Error in bulkSubmitPa");
    throw error;
  }
};
